import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

import { Popup } from '../Popup';

class Select extends Component {
  constructor (props) {
    super(props);

    this.defaultKey = 'default';

    this.state = {
      opened: false,
      value: props.value
    };

    this.name = props.name;
    this.label = props.label;
    this.items = props.items;
    this.scrolling = props.scrolling;
    this.labelCache = this.makeLabelCache(this.items);

    this.getLabel = this.getLabel.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.handleOpenPopup = this.handleOpenPopup.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  getLabel () {
    return this.labelCache[this.state.value || this.defaultKey];
  }

  makeLabelCache (items) {
    const cache = {};

    items.map(item => {
      if (item.type === 'option') {
        cache[item.value || this.defaultKey] = item.label;
      }
    });

    return cache;
  }

  shouldComponentUpdate (nextProps, nextState) {
    return nextProps.value !== this.state.value || nextState.opened !== this.state.opened;
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.opened) {
      document.addEventListener('click', this.handleClickOutside);
    } else {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside (e) {
    const nodeRef = findDOMNode(this.popupContainer);
    if (this.popupContainer !== e.target && nodeRef && !nodeRef.contains(e.target) && this.state.opened) {
      this.setState({ opened: false });
    }
  }

  handleOpenPopup (e) {
    e.preventDefault();

    this.setState({
      opened: !this.state.opened
    });
  }

  renderMenu () {
    const onUpdate = this.props.onUpdate;

    return (
      <Popup
        indentation={false}
        opened={this.state.opened} direction='bottom-right'
        mainOffset={0} secondaryOffset={0} ref={p => { this.popupContainer = p; }}
      >
        <ul className={'select-control-list' + (this.scrolling ? ' scrolling' : '')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {
            this.items.map(item => {
              if (item.type === 'group') {
                return <li key={item.value} className='group'>{item.value}</li>;
              } else {
                return (
                  <li
                    key={item.value}
                    className={'item' + (item.value === this.state.value ? ' selected' : '')}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({opened: false});
                      onUpdate(this.name, item.value);
                    }}
                  >
                    {item.label}
                  </li>
                );
              }
            })
          }
        </ul>

      </Popup>
    );
  }

  render () {
    const arrowClass = classNames(
      'button-select-value', 'button-flat', {
        'down': !this.state.opened,
        'up': this.state.opened
      });

    return (
      <div className={'select-control-box ' + this.name}>
        {this.label || ''}
        <div className='select-control-value' onClick={this.handleOpenPopup}>
          <button className={arrowClass} type='button'>
            { this.getLabel() }
          </button>

          {this.state.opened && this.renderMenu()}
        </div>
      </div>
    );
  }
}

Select.propTypes = {
  items: PropTypes.array.isRequired,
  label: PropTypes.string,                                 // название селекта
  name: PropTypes.string.isRequired,                       // имя свойства, которое меняет селект
  onUpdate: PropTypes.func.isRequired,                     // callback(name, item.value)
  scrolling: PropTypes.bool,
  value: PropTypes.oneOfType([                             // текущиее выбранное значение
    PropTypes.string,
    PropTypes.number
  ])
};

Select.defaultProps = {
  value: null,
  label: '',
  scrolling: false
};

export default Select;



// WEBPACK FOOTER //
// ./src/ui/Controls/Select.jsx